'use strict';

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var dom;
var videoUrl;
var scriptUrl;
var endpoint = 'https://www.vimeo.com/api/oembed.json';
var callback = 'embedVideo';

var embedVideo = function(video) {
	
	var div = document.getElementById('vimeo');

	// $f is created as a legacy global when the vimeo froogaloop library
	// is pulled in. check the application's /system/apps/corporate-photobiz/config.json
	// file to see this in action.
	var froogaloopLibrary = $f;

	div.innerHTML = unescape(video.html);

	var ifr = div.firstChild;
	
	ifr.addEventListener('load', function(e) {

		var player = froogaloopLibrary(ifr);

		player.addEvent('ready', function() {

			player.api('setVolume', 0);

		});

	});

};

var setupDom = function() {

	dom = {};

	dom.vimeoDiv = $('#vimeo');

};

var addEventHandlers = function() {

	window.addEventListener('DOMContentLoaded', setupPlayer);

};

var setupUrls = function() {

	var videoId = dom.vimeoDiv.attr('data-video-id');

	videoUrl = 'https://www.vimeo.com/' + videoId + '?api=1&player_Id=vimeoyo';

	scriptUrl = endpoint + '?url=' + encodeURIComponent(videoUrl) + '&autoplay=true' + '&callback=' + callback + '&width=420';

};

var setupPlayer = function() {

	var js = document.createElement('script');

	js.setAttribute('type', 'text/javascript');
	js.setAttribute('src', scriptUrl);

	document.getElementsByTagName('head').item(0).appendChild(js);

};

var exposeEmbedVideoFn = function() {

	window.embedVideo = embedVideo;

};

var init = function() {

	console.log('vimeo api initialized');

	setupDom();

	addEventHandlers();

	setupUrls();

	exposeEmbedVideoFn();

};

module.exports = {
	init: init
};
